import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import { normalColumn, actionEditColumn } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import { Button } from "primereact/button.js";


export default function P421List(props) {

    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 })
    const actionBodyEdit = (rowData = null) => props.setAction({...rowData, action: "U"});
    const actionBodyAdd = (rowData = null) => props.setAction({...rowData, action: "A"});

    const headerLabel = <span className="hidden-responsive">เพิ่มรายการใหม่</span>;
    const header = (
        <div className="table-header">
            <Button className="p-button p-button-success btn-hidden-responsive" label={headerLabel} icon="pi pi-plus" 
            onClick={() => actionBodyAdd()} 
            style={{ width: 170, marginLeft: "5px" }}
            autoFocus />
            <Button className="p-button btn-hidden-responsive" label="Sync ข้อมูลกล้องจากระบบ CIA" 
            onClick={() => props.setActionSync({})} 
            style={{ width: 210, marginLeft: "5px" }}
            autoFocus />
        </div>
    );
    

    return (
        <div className="datatable-responsive-modify">
            <DataTable
                // ref={(el) => dt = el}
                value={props.dataList}
                dataKey="id"
                paginator
                first={pageConf.first}
                rows={pageConf.rows}
                onPage={(e) => onPageChange(e, setPageConf)}
                rowsPerPageOptions={[5, 10, 25]}
                paginatorTemplate={paginatorTemplate()}
                currentPageReportTemplate={currentPageReportTemplate()}
                header={header}
                // globalFilter={globalFilter}
                emptyMessage="ไม่พบข้อมูล"
                className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                selectionMode="single"
            >
                <Column field="seq" header="ลำดับ" body={(e) => normalColumn(e, "seq", "ลำดับ")} sortable  style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="cameraId" header="รหัสกล้อง" body={(e) => normalColumn(e, "cameraId", "รหัสกล้อง")} sortable  style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="cameraName" header="ชื่อกล้อง" body={(e) => normalColumn(e, "cameraName", "ชื่อกล้อง")} sortable  style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="contractorName" header="บริษัท" body={(e) => normalColumn(e, "contractorName", "บริษัท")} sortable  style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column field="requestList" header="เลขที่ใบแจ้ง" body={(e) => normalColumn(e, "requestList", "เลขที่ใบแจ้ง")} sortable  style={{ textAlign: "center" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="updateUserName" header="ผู้แก้ไข" body={(e) => normalColumn(e, "updateUserName", "ผู้แก้ไข")} sortable  style={{ textAlign: "center", width: "15%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                <Column field="updateDt" header="วันที่แก้ไข" body={(e) => normalColumn(e, "updateDt", "วันที่แก้ไข")} sortable  style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                <Column header="แก้ไข" field="photoPath" body={(e) => actionEditColumn(e, actionBodyEdit)} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>

            </DataTable>
        </div>
    )
}